import * as $ from "jquery";
import { CancellationToken, OperationCanceledError } from "./task/cancellation";

export function animatedScrollByY(delta: number, durationInMs: number, animateEl = document.body) {
    if (delta !== 0) {
        const scrollYBefore = window.scrollY;
        window.scrollBy(0, delta);
        const possibleDelta = window.scrollY - scrollYBefore;
        window.scrollBy(0, -possibleDelta);

        const animateElStyle = animateEl.style;
        animateElStyle.transition = (animateElStyle as any).transition =
            `transform ${durationInMs}ms ease-in-out`;
        animateElStyle.transform = (animateElStyle as any).transform =
            `translateY(${-possibleDelta}px)`;

        const onEnd = () => {
            animateElStyle.transition = (animateElStyle as any).transition = '';
            animateElStyle.transform = (animateElStyle as any).transform = '';
            window.scrollBy(0, possibleDelta);
            animateEl.removeEventListener('transitionend', onEnd);
        };

        animateEl.addEventListener('transitionend', onEnd);
    }
}

export function scrollElementToY(container: HTMLElement, offset: number, duration: number,
    cancellationToken?: CancellationToken) {
    return new Promise<void>((resolve, reject) => {
        $(container).animate({
            scrollTop: offset
        }, duration, () => {
            resolve();
        });
        if (cancellationToken) {
            cancellationToken.register(() => {
                $(container).stop();
                reject(new OperationCanceledError(cancellationToken));
            });
        }
    });
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/animatedScroll.ts
 **/